import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  alertById,
  alertName,
  alertDbName,
  alertResults,
  alertContext,
  alertLastSaved,
  alertStructures,
  alertDescription,
} from '@Pages/Alerts/AlertsSelectors';
import withReducer from '@Hooks/withReducer';
import { open as openStructureDialog } from '@Containers/StructureDialog/StructureDialogAction';
import { handleViewDeleteModal } from '@Pages/Alerts/AlertsAction';
import { alertSelectedResultDate, alertSelectedRunId, alertSelectedResultHits } from './AlertItemSelectors';
import { selectResultOfAlert, fetchResultsInfo, openEditAlert } from './AlertItemActions';
import { alertItemReducerKey } from './AlertItemConstants';
import alertItemReducer from './AlertItemReducer';

function mapStateToProps(state, ownProps) {
  return {
    name: alertName(state, ownProps),
    alert: alertById(state, ownProps),
    dbName: alertDbName(state, ownProps),
    context: alertContext(state, ownProps),
    results: alertResults(state, ownProps),
    lastSaved: alertLastSaved(state, ownProps),
    structures: alertStructures(state, ownProps),
    description: alertDescription(state, ownProps),
    selectedResultDate: alertSelectedResultDate(state, ownProps),
    selectedRunId: alertSelectedRunId(state, ownProps),
    selectedResultHits: alertSelectedResultHits(state, ownProps),
  };
}

const mapDispatchToProps = {
  fetchResultsInfo,
  selectResultOfAlert,
  openStructureDialog,
  handleViewDeleteModal,
  openEditAlert,
};

const enhancedAlertItem = compose(withReducer(alertItemReducerKey, alertItemReducer), connect(mapStateToProps, mapDispatchToProps));
export default enhancedAlertItem;
